import { Component, OnInit, Input, Output, EventEmitter, Inject, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import * as sweetalertService from 'angular-sweetalert-service';
import { Sort, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatCheckboxModule } from '@angular/material';
import { UUID } from 'angular2-uuid';
//grid
import { AgGridNg2 } from 'ag-grid-angular';

import { GlobalsService } from '../services/globals.service';
import { UtilesService } from '../services/utiles.service';
import { ViajeService } from '../services/viaje.service';
import { UsuarioService } from '../services/usuario.service';

import { Viaje } from '../Models/Viaje';
import { Usuario } from '../Models/Usuario';

@Component({
  selector: 'app-cerrar-viaje-forzado',
  templateUrl: './cerrar-viaje-forzado.component.html',
  styleUrls: ['./cerrar-viaje-forzado.component.css']
})
export class CerrarViajeForzadoComponent implements OnInit {

  public viaje: Viaje = new Viaje();
  public viajes: Viaje[];

  public usuario: Usuario = new Usuario();
  public usuarios: Usuario[];

  public tipoViaje: string;

  @ViewChild('agGrid') agGrid: AgGridNg2;

  columnDefs = [
    { headerName: 'Placa', field: 'idVehiculo' },
    { headerName: 'Fecha Creación', field: 'fechaCreacion' },
    { headerName: 'Fecha Asignación', field: 'fechaAsignacion' },
    { headerName: 'Estado', field: 'estado' },
  ];

  rowData: any[];

  constructor(private viajeService: ViajeService,
    private globalServices: GlobalsService,
    private utilService: UtilesService,
    private usuarioService: UsuarioService,

  ) {


  }

  ngOnInit() {

    this.tipoViaje = "Reactivar";
    this.CargarUsuarios();
  }


  //carga los usuarios
  CargarUsuarios() {

    try {

      this.usuarioService.ObtenerUsuarios(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.usuarios = data;

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarUsuarios: " + error);
    }
  }

  RutaSeleccionada() {
    this.CargarViajes();
  }

  CargarViajes() {
    try {
      //si el tipo viaje lo van a reactivar
      if (this.tipoViaje === "Reactivar") {
        this.viajeService.ObtenerViajesSincronizadosUsuario(this.globalServices.ObtenerCompania(), this.usuario.idUsuario).subscribe(
          data => {
            this.viajes = data;

            this.rowData = this.viajes;
          },
          err => {
            console.clear();
            console.log(err._body);
          });
      }
      //si lo van a forzar
      if (this.tipoViaje === "Forzar") {
        this.viajeService.ObtenerViajesUsuario(this.globalServices.ObtenerCompania(), this.usuario.idUsuario).subscribe(
          data => {
            this.viajes = data;

            let filtroDatosSeleccionados = this.viajes.filter(fil => fil.estado != 'FINALIZADO');
            this.rowData = filtroDatosSeleccionados;
          },
          err => {
            console.clear();
            console.log(err._body);
          });
      }




    } catch (error) {
      console.log("CargarViajes: " + error);
    }

  }


  //click en una row
  onCellClicked($event) {

    console.log('onCellClicked: ' + $event.rowIndex + ' ' + $event.colDef.field);
    let row = $event.rowIndex;
    var datos = JSON.parse(JSON.stringify($event.data));


    if (this.tipoViaje === "Reactivar") {
      swal({
        title: "Reactivar viaje",
        text: "¿Desea Reactivar el viaje?",
        buttons: {
          Cancelar: true,
          Aceptar: true,


        }
      }).then(val => {
        if (val === "Cancelar") {
          return;

        }

        if (val === "Aceptar") {


          this.viajeService.ActualizarReactivarViaje(datos).subscribe(
            data => {

              swal("Viaje reactivado con exito", "", "success");

              this.agGrid.api.setRowData([]);
              this.agGrid.api.setColumnDefs([]);
              this.agGrid.api.refreshView();

              this.agGrid.api.setRowData(this.rowData);
              this.agGrid.api.setColumnDefs(this.columnDefs);
              this.agGrid.api.refreshView();


            },
            err => {
              console.error(err);
              swal("Ocurrio un error no se pudo reactivar el viaje", "", "error");
            }

          );

        }
      }

      );
    }


    if (this.tipoViaje === "Forzar") {

      swal({
        title: "Anular viaje",
        text: "¿Desea forzar el viaje?",
        buttons: {
          Cancelar: true,
          Aceptar: true,


        }
      }).then(val => {
        if (val === "Cancelar") {
          return;

        }

        if (val === "Aceptar") {


          this.viajeService.ActualizarViajeFinalizado(datos).subscribe(
            data => {

              swal("Viaje forzado con exito", "", "success");

              this.agGrid.api.setRowData([]);
              this.agGrid.api.setColumnDefs([]);
              this.agGrid.api.refreshView();

              this.agGrid.api.setRowData(this.rowData);
              this.agGrid.api.setColumnDefs(this.columnDefs);
              this.agGrid.api.refreshView();


            },
            err => {
              console.error(err);
              swal("Ocurrio un error no se pudo forzar el viaje", "", "error");
            }

          );

        }
      }

      );
    }



  }


}